export default __webpack_public_path__ + "images/f713818dd7a6680111714f928bd9c17e.png";